// PAQUETES
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from "sweetalert2";
// COMPONENTES
import ZonaCargando from '../alertas/zonaCargando';
// FUNCIONES
import { formatearMoneda } from "../../funcionesDatos/Moneda";
import { formatearFechaHora } from "../../funcionesDatos/fechas";

function DesembolsoIndividual(){
    const location = useLocation();
    const navigate = useNavigate();
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; 

    const [cargando, setCargando]     = useState(false);
    const cargandoFinal               = Boolean(cargandoUsuario) || Boolean(cargando);

    const state       = location?.state || {};
    const idProveedor = state?.idProveedor || "NA";
    const vendedor    = state?.vendedor || {};
    const reservas    = Array.isArray(state?.reservas) ? state.reservas : [];
    const totalAPagar = Number(state?.totalAPagar || 0);
    const totalReservas = Number(state?.totalReservas || reservas.length || 0);

    const nombreCompleto = `${vendedor?.nombre || ""} ${vendedor?.apellido || ""}`.trim() || "Vendedor sin nombre";
    const avatar = vendedor?.avatar || "/imagenes/marca/avatar.png";
    const username = vendedor?.username || "usuario";
    const moneda = reservas?.[0]?.cobro?.moneda || "COP";
    const cuentaBancaria = vendedor?.cuentaBancariaPrincipal || null;

    function mostrarMoneda(valor) {
        return formatearMoneda(Number(valor || 0), moneda);
    }

    function mostrarFecha(fecha) {
        return formatearFechaHora(fecha) || "NA";
    }

 
    async function pagarDesembolsoIndividual(){
    try {
        const idsReservas = reservas
            .map((reserva) => reserva?._id || reserva?.idReserva)
            .filter(Boolean);

        const res = await axios.post("/pagar-desembolso-individual", { params: { idProveedor, idsReservas } });

        //console.log("Respuesta pago desembolso:", res.data);

        await Swal.fire({
            icon: "success",
            title: "Desembolso enviado",
            html: `
                <div style="text-align:left; font-size:16px; line-height:1.6;">
                    <p style="margin-bottom:10px;">El pago del vendedor fue enviado correctamente a Wompi Pagos a Terceros.</p>
                    <p style="margin-bottom:10px;"><b>Estado inicial:</b> ${res?.data?.wompi?.estado || "Programado"}</p>
                    <p style="margin-bottom:10px;"><b>Referencia:</b> ${res?.data?.wompi?.referenciaLote || "NA"}</p>
                    <p style="margin-bottom:0;">El estado final se actualizará automáticamente cuando Wompi envíe el webhook correspondiente.</p>
                </div>
            `,
            confirmButtonText: "Continuar",
            customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
        });

        navigate(-1);
    }
    catch (err) {
        console.log("Error pagando desembolso individual:", err);
        await Swal.fire({
            icon: "error",
            title: "No se pudo enviar el desembolso",
            text: err?.response?.data?.mensaje || err?.response?.data?.errorWompi?.message || "Ocurrió un error al intentar pagar el desembolso. Revisa la consola o intenta nuevamente.",
            confirmButtonText: "Entendido",
            customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
        });
    }
    }

    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ?    
        <div className="container-fluid py-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                <div>
                    <button
                        type="button"
                        className="btn btn-link text-decoration-none px-0 mb-2"
                        onClick={() => navigate(-1)}
                    >
                        ← Volver a desembolsos
                    </button>
                    <h1 className="h2 text-dark mb-1">Desembolso de vendedor</h1>
                    <p className="text-secondary mb-0">Detalle de reservas listas para pagar a este proveedor.</p>
                </div>

                <button
                    type="button"
                    className="btn btn-primary rounded-pill px-4 py-2 fw-semibold"
                    disabled={reservas.length === 0 || totalAPagar <= 0 || !cuentaBancaria}
                    onClick={() => pagarDesembolsoIndividual() }
                >
                    <i className="bi bi-send-check me-2"></i>
                    Pagar este desembolso
                </button>
            </div>

            <div className="row g-3 mb-4">
                <div className="col-12 col-xl-5">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-4">
                            <div className="d-flex align-items-center gap-3">
                                <img
                                    src={avatar}
                                    alt={nombreCompleto}
                                    style={{
                                        width: "86px",
                                        height: "86px",
                                        objectFit: "cover",
                                        borderRadius: "18px",
                                        border: "1px solid var(--color-border)",
                                    }}
                                />

                                <div className="min-w-0">
                                    <h4 className="fw-bold text-dark mb-1">{nombreCompleto}</h4>
                                    <div className="text-secondary">@{username}</div>
                                    <div className="text-secondary">{vendedor?.email || "Sin correo"}</div>
                                    <div className="text-secondary">ID proveedor: {idProveedor}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-4">
                            <span className="text-secondary fw-semibold">Total a pagar</span>
                            <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(totalAPagar)}</h3>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6 col-xl-2">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-4">
                            <span className="text-secondary fw-semibold">Reservas</span>
                            <h3 className="fw-bold text-dark mb-0 mt-1">{totalReservas}</h3>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-xl-2">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-4">
                            <span className="text-secondary fw-semibold">Cuenta bancaria</span>
                            <h5 className={`fw-bold mb-0 mt-1 ${cuentaBancaria ? "text-success" : "text-danger"}`}>
                                {cuentaBancaria ? "Inscrita" : "Falta"}
                            </h5>
                        </div>
                    </div>
                </div>
            </div>

            {cuentaBancaria ? (
                <div className="alert alert-light border rounded-4 mb-4">
                    <strong>Cuenta principal:</strong> {cuentaBancaria?.banco || "NA"} · {cuentaBancaria?.tipoCuenta || "NA"} · {cuentaBancaria?.numeroCuenta || "NA"} · Titular: {cuentaBancaria?.nombreTitular || "NA"}
                </div>
            ) : (
                <div className="alert alert-warning rounded-4 mb-4">
                    Este vendedor no tiene cuenta bancaria inscrita. No se puede enviar el pago a Wompi todavía.
                </div>
            )}

            <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="px-4 py-3">Reserva</th>
                                    <th className="px-4 py-3">Disponible desde</th>
                                    <th className="px-4 py-3">Estado pago</th>
                                    <th className="px-4 py-3 text-end">Monto proveedor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reservas.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="px-4 py-4 text-secondary">
                                            No llegaron reservas para este desembolso.
                                        </td>
                                    </tr>
                                ) : reservas.map((reserva) => (
                                    <tr key={reserva?._id || reserva?.idReserva}>
                                        <td className="px-4 py-3">
                                            <div className="fw-semibold text-dark">{reserva?._id || reserva?.idReserva || "Reserva"}</div>
                                            <div className="text-secondary small">Estado: {reserva?.estado || "NA"}</div>
                                            {Number(reserva?.cobro?.descuentoPrimeraCompra || 0) > 0 && (
                                                <span className="badge rounded-pill mt-1" style={{ background: "rgba(var(--verde-esmeralda-rgb), 0.12)", color: "var(--verde-esmeralda)", fontSize: "0.7rem" }}>
                                                    <i className="bi bi-gift-fill me-1"></i>Con descuento 1ra compra
                                                </span>
                                            )}
                                        </td>
                                        <td className="px-4 py-3 text-secondary">
                                            {mostrarFecha(reserva?.desembolso?.disponibleDesde)}
                                        </td>
                                        <td className="px-4 py-3">
                                            <span className="badge text-bg-success rounded-pill">
                                                {reserva?.cobro?.estadoPago || "NA"}
                                            </span>
                                        </td>
                                        <td className="px-4 py-3 text-end fw-bold text-dark">
                                            {mostrarMoneda(reserva?.desembolso?.montoProveedor)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    :null
    }
    </div>
    )
}

export default DesembolsoIndividual;